import { PanelShell } from './PanelShell';

const quests = [
  ['FLASH FOSSIL', 'Watch One Order of Doom without your browser exploding.', '0 / 1'],
  ['CORRUPTED SAVE', 'Enter the original Fukered ROM archive.', 'READY'],
  ['LORE GOBLIN', 'Inspect three Fukédex dossiers.', '1 / 3'],
  ['MEME LAB', 'Export a Fukecard from the old chaos machine.', '0 / 1']
];

export function ArcadePanel() {
  return (
    <PanelShell eyebrow="WEEKEND MODE // NO ORACLE NEEDED" title="FLASH FOSSIL ARCADE">
      <p className="lede">
        Markets asleep? Dig through the cursed archive. Quests unlock heroes and cosmetics,
        never financial rewards.
      </p>
      <div className="quest-list">
        {quests.map(([title, copy, progress], index) => (
          <button key={title} className="quest-item">
            <span>{String(index + 1).padStart(2, '0')}</span>
            <div>
              <strong>{title}</strong>
              <small>{copy}</small>
            </div>
            <em>{progress}</em>
          </button>
        ))}
      </div>
    </PanelShell>
  );
}

